import React, { FunctionComponent } from 'react';
import { Box, MenuItem, Pagination, Select, Typography } from '@mui/material';

import { PAGE_SIZES } from './runHistoryApi';

interface IRunHistoryPaginationProps {
  /** 1-based current page. */
  page: number;
  pageCount: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const RunHistoryPagination: FunctionComponent<IRunHistoryPaginationProps> = ({
  page,
  pageCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) => (
  <Box
    sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}
    component="nav"
    aria-label="Run history pagination"
  >
    <Pagination
      count={pageCount}
      page={Math.min(page, pageCount)}
      onChange={(_, next) => onPageChange(next)}
      showFirstButton={false}
      showLastButton={false}
      color="primary"
      size="small"
      sx={{ flexGrow: 1 }}
    />
    <Typography
      variant="body2"
      component="label"
      htmlFor="run-history-page-size"
    >
      Rows per page
    </Typography>
    <Select
      size="small"
      id="run-history-page-size"
      value={pageSize}
      onChange={(e) => onPageSizeChange(Number(e.target.value))}
    >
      {PAGE_SIZES.map((size) => (
        <MenuItem key={size} value={size}>
          {size}
        </MenuItem>
      ))}
    </Select>
  </Box>
);

export default RunHistoryPagination;
